import React from "react";

import { ArticlePageTile } from "@reactivated";

import { ImageChooserBlock } from "@thelabnyc/thelabui/src/components/ImageChooserBlock";
import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import { getRatioForAspect } from "../Heros/Article";
import { getThemeClass } from "../ThemedModule";
import { YoutubeThumbnail } from "../VideoGrid";

import styles from "./TileImage.module.scss";

type Nullable<T> = { [K in keyof T]: T[K] | null };

type ArticleTileProps = Pick<ArticlePageTile, "image"> &
    Partial<
        Nullable<
            Pick<
                ArticlePageTile,
                "image_aspect_ratio" | "title" | "module_theme"
            >
        >
    >;

type TileImageProps = {
    value:
        | (ArticleTileProps & {
              tile_type: ArticlePageTile["tile_type"] | "video";
              embed_id?: string | null;
          })
        | null;
    attrs?: React.ComponentProps<"div">;
};

export const TileImage = (props: TileImageProps) => {
    if (!props.value) return;
    if (props.value.tile_type === "video") {
        return (
            <div
                {...props.attrs}
                className={concatClassNames([
                    styles.image,
                    props.attrs?.className,
                ])}
            >
                {props.value.embed_id && (
                    <YoutubeThumbnail videoId={props.value.embed_id} />
                )}
            </div>
        );
    } else if (props.value.tile_type === "guide") {
        return (
            <div
                {...props.attrs}
                className={concatClassNames([
                    styles.guideImage,
                    getThemeClass(props.value.module_theme),
                    props.attrs?.className,
                ])}
            >
                <p className={styles.guideTitle}>{props.value.title}</p>
                {props.value.image && (
                    <ImageChooserBlock value={props.value.image} />
                )}
            </div>
        );
    } else if (props.value.image)
        return (
            <div
                {...props.attrs}
                className={concatClassNames([
                    styles.image,
                    props.attrs?.className,
                ])}
            >
                <ImageChooserBlock
                    attrs={{
                        style: props.value.image_aspect_ratio
                            ? {
                                  "--image-ar": getRatioForAspect(
                                      props.value.image_aspect_ratio,
                                  ),
                              }
                            : undefined,
                    }}
                    value={props.value.image}
                    imageAttrs={{ alt: props.value.title ?? "" }}
                />
            </div>
        );
};
